export default {
    title: '字根',
    intro: `字根通过观察"字"和"包含该字的单词"，可以学习单词是<br>如何构成的原理和过程。通过字根<br>训练，可以轻松推断出不认识的单词的含义。`,
    quizIntro: '回忆之前学过的字，尝试解题吧。',
    header: {
        navigator: '{level}级 第{round}次',
    },
    subject: {
        letter: '学习字根',
        relation: '确认语义关系',
        board: '我学过的字根',
        lesson: '字根训练',
        quiz: '字根小测验',
    },
    indicator: {
        letter: '点击字，学习字根的形状、读音和含义。',
        word: '点击单词，了解字根在单词中的用法。',
        words: '学习包含字根的两个单词。',
        choose1: '下面两个单词中有一个共同的字。<br/>',
        choose2: "两个单词中，使用了'word'字的单词是哪一个？",
        relation: '两个字根的语义关系是什么？',
        quiz: '填入空白处正确的字是什么？',
    },
    study: {
        example: '例句',
        meaning: '含义',
        sound: '发音',
        listen: '听发音',
    },
    modal: {
        notCompleted: '完成上一轮的所有学习后才能进行学习。',
        moveToWaiting: '要移动到等候室吗？',
        invalidAccess: '访问无效。',
    },
    exitModal: {
        title: '训练尚未结束！',
        message: '现在停止的话，训练内容可能不会被保存！',
        continue: '继续',
        stop: '停止',
    },
    result: {
        totalQuestionMessage: '在total道题中答对了score道。',
        checkMessage: '请仔细确认所有正确答案。',
        correct: '正确',
        selected: '已选',
        incorrect: '错误',
    },
    button: {
        nextWord: '下一步学习',
        nextLevel: '进入下一关',
        start: '开始',
        finishStudy: '结束学习',
        finishExam: '结束考试',
        confirm: '确认',
    },
    relation: {
        synonym: { name: '近义', description: '两个字形状不同，但含义相似' },
        opposite: { name: '反义', description: '两个字的含义 互相相反' },
        hierarchy: { name: '上下位', description: '一个字的含义 包含另一个字的含义' },
        same: { name: '同音', description: '两个字发音相同，但含义不同' },
        different: { name: '多义', description: '一个字有 多种含义' },
    },
};
